import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import * as Sentry from "@sentry/vue";
import 'nprogress/nprogress.css';
import './style.css';

import { createPinia } from 'pinia';
import { useAuthStore } from './stores/auth';
import type { PermissionCode } from '@/constants/permissions';
import tooltip from './directives/tooltip';
import Icon from './components/Icon/Icon.vue';

const app = createApp(App);

// Register global directives
app.directive('tooltip', tooltip);

// Register global components
app.component('Icon', Icon);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  enabled: import.meta.env.PROD
});


const pinia = createPinia();

app.use(pinia);
app.use(router);

app.component('Headers', Headers);
const authStore = useAuthStore();

router.beforeEach(async (to, _from, next) => {
  await authStore.checkAuth();

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next('/');
  }

  if (!to.meta.requiresAuth && authStore.isAuthenticated) {
    await authStore.checkAuth();
    return next('/main');
  }

  const requiredPermissions = to.meta.requiredPermissions as
    | PermissionCode
    | PermissionCode[]
    | undefined;
  if (requiredPermissions && !authStore.hasAnyPermission(requiredPermissions)) {
    return next('/main');
  }

  next();
});

app.mount('#app');
